import React from 'react';
import moment from 'moment';
import { SuspendedPaymentOrder } from '../../../api/payments';
import { PaymentMethod, PaymentStatusLabel } from '../../../interfaces/payments';
import { mapPaymentMethod } from '../utils';

const PRODUCT_TYPE_LABEL: Record<string, string> = {
  EVENT: 'Evento',
  COURSE: 'Corso',
  SUBSCRIPTION: 'Tessera',
  OTHER: 'Altro',
};

interface Props {
  order: SuspendedPaymentOrder;
}

const SuspendedPaymentRow: React.FC<Props> = ({ order }) => {
  return (
    <tr className='cursor-default'>
      <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-900'>
        {order.profile.name} {order.profile.surname}
      </td>
      <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-500'>
        {order.profile.email || '-'}
      </td>
      <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-500'>
        {PRODUCT_TYPE_LABEL[order.productType] || order.productType}
      </td>
      <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-500'>
        {order.id}
      </td>
      <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-500'>
        {order.payment.id}
      </td>
      <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-500'>
        {order.payment.createdAt
          ? moment(order.payment.createdAt).format('DD/MM/YYYY HH:mm')
          : '-'}
      </td>
      <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-500'>
        {mapPaymentMethod(order.payment.method as PaymentMethod)}
      </td>
      <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-500'>
        {PaymentStatusLabel[order.payment.status as keyof typeof PaymentStatusLabel] || order.payment.status}
      </td>
      <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-500'>
        {order.payment.amount != null
          ? `€ ${order.payment.amount.toFixed(2)}`
          : '-'}
      </td>
    </tr>
  );
};

export default SuspendedPaymentRow;
